import * as yup from "yup";

export const changePasswordSchema = yup.object({
  new_password: yup
    .string()
    .required("Пароль обязателен")
    .min(8, "Пароль должен содержать не менее 8 символов")
    .matches(
      /[a-z]/,
      "Пароль должен содержать хотя бы одну строчную букву латинницы"
    )
    .matches(
      /[A-Z]/,
      "Пароль должен содержать хотя бы одну заглавную букву латинницы"
    ),
  current_password: yup
    .string()
    .required("Пароль обязателен")
    .min(8, "Пароль должен содержать не менее 8 символов")
    .matches(
      /[a-z]/,
      "Пароль должен содержать хотя бы одну строчную букву латинницы"
    )
    .matches(
      /[A-Z]/,
      "Пароль должен содержать хотя бы одну заглавную букву латинницы"
    ),
  double_password: yup
    .string()
    .required("Подтверждение пароля обязательно")
    .oneOf([yup.ref("new_password")], "Пароли не совпадают"),
});

export type UpdateUserFormValues = yup.InferType<typeof changePasswordSchema>;
